import React from 'react';
import { useSelector } from 'react-redux';
import { optimizationPricesResultSelector } from '../../../../../../../reducers/OtimizacaoPrecos';
import { ChartVariationContainer } from './ChartVariation';

interface ChartVariationProfitProps {
  isLoading: boolean;
  containerRefCharts: any;
}
export const ChartVariationProfit = ({ isLoading, containerRefCharts }: ChartVariationProfitProps) => {
  const { tabs } = useSelector(optimizationPricesResultSelector);
  const { charts } = tabs.analysis;

  return (
    <ChartVariationContainer
      containerRefCharts={containerRefCharts}
      chart={charts.profit}
      title="Gráfico da variação de lucro"
      titleYAxis="variação de lucro"
      isLoading={isLoading}
    />
  );
};
